import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { FirmadaPanelKartComponent } from './firmada-panel-kart.component';
import { FirmadaPanelEditComponent } from './firmada-panel-edit.component';

@DinamikBilesen({
  id: 'hmi-firmada-panel',
  baslik: 'Firmada Panel',
  aciklama: 'Seçilen kart okuyucularında şu an firmada olan kişileri resim ve isim ile gösterir',
  ikon: 'team',
  kategori: 'hmi',
  etiketler: ['rfid', 'personel', 'firmada', 'panel', 'kart-okuyucu'],
  oncelik: 11,
})
class HmiFirmadaPanelBilesen {
  paylasilmis_kart = FirmadaPanelKartComponent;
  paylas_kutusu    = FirmadaPanelEditComponent;
  widget           = FirmadaPanelKartComponent;
  widget_kucuk     = FirmadaPanelKartComponent;
}
